module.exports = __webpack_public_path__ + "fonts/baronsans-medium-webfont.24e6d403.woff";